<template>
  <router-view />
</template>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

body {
  background: #f0f2f5;

  li {
    list-style: none;
  }
}

.el-card.is-always-shadow {
  box-shadow: 0 1px 1px rgba(245, 161, 161, 0.15);
}
</style>
